
<div v-if="visible" class="app-info-card" @click.stop>
    <div class="app-info-content">
        <!-- Title Header -->
        <div class="app-info-header">
            <h4>{{ appData.title }}</h4>
        </div>

        <div class="app-info-features">
            <!-- Analysis Tool Type -->
            <div v-if="appData.analysisType" class="feature-item">
                <img :src="infoIcon" class="feature-icon" alt="" />
                <div class="feature-text">
                    <strong>What kind of analysis tool is this?</strong>
                    <p>{{ appData.analysisType }}</p>
                </div>
            </div>

            <!-- Dataset Scope -->
            <div v-if="appData.datasetScope" class="feature-item">
                <img :src="targetIcon" class="feature-icon" alt="" />
                <div class="feature-text">
                    <strong>Scope of dataset</strong>
                    <p>{{ appData.datasetScope }}</p>
                </div>
            </div>

            <!-- Granularity -->
            <div v-if="appData.granularity" class="feature-item">
                <img :src="searchIcon" class="feature-icon" alt="" />
                <div class="feature-text">
                    <strong>Granularity &amp; demo availability</strong>
                    <p>{{ appData.granularity }}</p>
                </div>
            </div>
        </div>

        <!-- Bottom section with capability indicators - only shown if capabilities exist -->
        <div v-if="appData.capabilities && appData.capabilities.length > 0" class="capability-section">
            <div class="capability-categories">
                <!-- Only show location category if there are active location capabilities -->
                <div v-if="hasLocationCapabilities" class="capability-category">
                    <div class="capability-category-label">Locations</div>
                    <div class="capability-group-items">
                        <div v-for="cap in locationCapabilities" :key="cap.key" class="capability-item" :class="{ 'capability-active': isCapabilityActive(cap.key) }" :id="cap.key">
                            <div class="capability-icon-wrapper">
                                <img :src="cap.icon" class="capability-icon" alt="" />
                                <b-tooltip :target="cap.key" triggers="hover"> {{ cap.tooltipText }} </b-tooltip>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Only show screen category if there are active screen capabilities -->
                <div v-if="hasScreenCapabilities" class="capability-category">
                    <div class="capability-category-label">Screens</div>
                    <div class="capability-group-items">
                        <div v-for="cap in screenCapabilities" :key="cap.key" class="capability-item" :class="{ 'capability-active': isCapabilityActive(cap.key) }" :id="cap.key">
                            <div class="capability-icon-wrapper" :class="{ 'capability-icon-devices': cap.key === 'devices' }">
                                <img :src="cap.icon" class="capability-icon" :class="{ 'capability-icon-wide': cap.key === 'devices' }" alt="" />
                                <b-tooltip :target="cap.key" triggers="hover"> {{ cap.tooltipText }} </b-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
